
export const OrderCreate = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Create Order</h1>
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-gray-500">Create order form</p>
      </div>
    </div>
  );
};
